import React from 'react';
import Layout from '../Components/Layout';

function Insights() {
  return (
    <Layout>
      <h2>Insights</h2>
      <p>Insights page content goes here.</p>
    </Layout>
  );
}

export default Insights;
